import { useState, useEffect } from "react";
import {
  Autocomplete,
  DatePicker,
  Grid,
  TextField,
  FormControl,
  Chip,
  Select,
  MenuItem,
} from "../../../../components";
import { PessoaService, AtivoServicoService } from "../../../../services";
import { responseErros } from "../../../../utils";

const FormFiltroAvancado = ({
  valueInput,
  onChangeInput,
  valueDate,
  onChangeDate,
  valueAutocomplete,
  onChangeAutocomplete,
  onChangeMultipleStatus,
}) => {
  const pessoaService = new PessoaService();
  const ativoServicoService = new AtivoServicoService();
  const [clienteList, setClienteList] = useState([]);
  const [ativoList, setAtivoList] = useState([]);

  const statusList = [
    { id: "ABERTO", descricao: "ABERTO", cor: "#4FBB53" },
    { id: "IMPORTADO", descricao: "IMPORTADO", cor: "#004780" },
  ];

  useEffect(() => {
    buscarClientes();
    buscarAtivos();
  }, []);

  const buscarClientes = () => {
    const filtros = {
      nonPaginated: true,
      tiposPessoaId: 1,
      attributes: ["id", "nomeRazaoSocial"],
    };
    pessoaService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setClienteList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const statusSelecionados = statusList.filter((s) => {
    return valueInput("status")?.includes(s.id);
  });

  const buscarAtivos = () => {
    ativoServicoService.getAll().then((result) => {
      if (!result.isAxiosError) {
        const ativosComCampoChave = (result.data || []).filter(
          (ativo) =>
            ativo?.ativado &&
            ativo?.camposPersonalizados?.some((campo) => campo.campoChave),
        );
        setAtivoList(ativosComCampoChave);
      } else {
        responseErros(result);
      }
    });
  };

  const ativoSelecionado = valueAutocomplete(ativoList, "ativoId");

  const campoChaveAtivo = ativoSelecionado?.camposPersonalizados?.find(
    (campo) => campo.campoChave,
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          id="numeroDocumento"
          name="numeroDocumento"
          label="Nº Documento"
          variant="outlined"
          margin="normal"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("numeroDocumento")}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="clienteId"
            name="clienteId"
            options={clienteList}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
            getOptionSelected={(option, value) =>
              option?.nomeRazaoSocial === value?.nomeRazaoSocial
            }
            renderInput={(params) => (
              <TextField {...params} label="Cliente" variant="outlined" />
            )}
            onChange={(e, value) => onChangeAutocomplete("clienteId", value)}
            value={valueAutocomplete(clienteList, "clienteId")}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataCreatedAtStart"
          name="dataCreatedAtStart"
          label="Data Abertura De"
          format="dd/MM/yyyy"
          value={valueDate("dataCreatedAtStart")}
          onChange={(date) => onChangeDate("dataCreatedAtStart", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataCreatedAtEnd"
          name="dataCreatedAtEnd"
          label="Data Abertura Até"
          format="dd/MM/yyyy"
          value={valueDate("dataCreatedAtEnd")}
          onChange={(date) => onChangeDate("dataCreatedAtEnd", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataVencimentoStart"
          name="dataVencimentoStart"
          label="Data Fechamento De"
          format="dd/MM/yyyy"
          value={valueDate("dataVencimentoStart")}
          onChange={(date) => onChangeDate("dataVencimentoStart", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataVencimentoEnd"
          name="dataVencimentoEnd"
          label="Data Fechamento Até"
          format="dd/MM/yyyy"
          value={valueDate("dataVencimentoEnd")}
          onChange={(date) => onChangeDate("dataVencimentoEnd", date)}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          id="status"
          name="status"
          options={statusList}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => option?.status || ""}
          onChange={(_, newValue) => onChangeMultipleStatus(newValue)}
          value={statusSelecionados}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Status"
              fullWidth
            />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              {option.status}
              <i
                className="ph-fill ph-circle"
                style={{ color: `${option.cor}`, marginLeft: 8 }}
              ></i>
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={index}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {option.status}
                    <i
                      className="ph-fill ph-circle"
                      style={{ color: `${option.cor}`, marginLeft: 6 }}
                    ></i>
                  </div>
                }
              />
            ))
          }
        />
      </Grid>
      {ativoList.length > 0 && (
        <>
          <Grid item xs={6}>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="ativoId"
                name="Ativo"
                options={ativoList}
                autoHighlight
                disablePortal
                getOptionLabel={(option) => option?.nome ?? ""}
                getOptionSelected={(option, value) => option?.id === value?.id}
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField {...params} label="Ativo" variant="outlined" />
                )}
                onChange={(_, newValue) =>
                  onChangeAutocomplete("ativoId", newValue)
                }
                value={valueAutocomplete(ativoList, "ativoId")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            {campoChaveAtivo?.type === "enum" ? (
              <Select
                id="ativoCampoChave"
                name="ativoCampoChave"
                label={campoChaveAtivo.label}
                fullWidth
                onChange={(event) => onChangeInput(event)}
                value={valueInput("ativoCampoChave")}
                SelectProps={{
                  MenuProps: {
                    disablePortal: true,
                    PaperProps: { sx: { zIndex: 1600 } },
                  },
                }}
              >
                <MenuItem value="">Todos</MenuItem>
                {(campoChaveAtivo.values || "")
                  .split(",")
                  .filter((item) => item)
                  .map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            ) : (
              <TextField
                id="ativoCampoChave"
                name="ativoCampoChave"
                label={campoChaveAtivo?.label || "Campo Chave"}
                variant="outlined"
                fullWidth
                disabled={!ativoSelecionado}
                onChange={(event) => onChangeInput(event)}
                value={valueInput("ativoCampoChave")}
              />
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default FormFiltroAvancado;
